export default {
  // Aqua variant - matches aqua_input styling
  aqua: {
    container: "relative inline-block text-left w-full",
    button: "inline-flex justify-between w-full rounded-full border border-gray_3 px-4 py-3 bg-theme_white text-base font-normal text-text focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-all",
    panel: "absolute origin-top-right rounded-2xl shadow-lg bg-theme_white ring-1 ring-gray_3 focus:outline-none mt-2 z-[9999]",
    searchInput: "w-full px-4 py-2 text-base border-b border-gray_3 rounded-t-2xl outline-none focus:outline-none focus:border-primary bg-theme_white text-text",
    searchContainer: "border-b border-gray_3",
    menuContainer: "rounded-b-2xl overflow-hidden max-h-60 overflow-y-auto scrollbar-thin scrollbar-thumb-gray_3 scrollbar-track-theme_white",
    menuItem: "text-text px-4 py-3 hover:bg-primary_lt/20 cursor-pointer transition-colors",
    menuItemSelected: "px-4 py-3 bg-primary_lt/40 border-l-4 border-primary cursor-pointer text-primary font-medium transition-colors",
    menuItemDisabled: "px-4 py-3 text-gray_2 cursor-not-allowed",
    selectAllContainer: "px-4 py-3 hover:bg-primary_lt/20 cursor-pointer",
    divider: "border-t border-gray_3 my-1",
    resetButton: "absolute right-3 top-1/2 transform -translate-y-1/2 p-1 text-gray_2 hover:text-primary transition-colors",
    highlight: "ring-2 ring-primary ring-opacity-50 border-primary",
    selectedText: "text-text font-normal",
    placeholderText: "text-gray_2",
  },

  // Default variant
  default: {
    container: "relative inline-block text-left w-full",
    button: "inline-flex justify-between w-full rounded-md border border-bordered px-4 py-2 bg-paper text-sm font-medium text-text focus:outline-none focus:ring-1 focus:ring-primary focus:ring-offset-2",
    panel: "absolute origin-top-right rounded-md shadow-md bg-paper ring-1 ring-bordered focus:outline-none mt-2 z-[9999]",
    searchInput: "w-full px-3 py-1 text-sm border rounded border-bordered rounded outline-none focus:outline-none focus:border-primary focus:shadow-none bg-canvas text-text",
    searchContainer: "p-2 border-b border-neutral_2",
    menuContainer: "rounded-lg overflow-hidden max-h-60 overflow-y-auto scrollbar-thin scrollbar-thumb-neutral_2 scrollbar-track-paper",
    menuItem: "text-text px-4 py-2 hover:bg-canvas cursor-pointer",
    menuItemSelected: "px-4 py-2 bg-primary bg-opacity-10 border-l-4 border-primary cursor-pointer text-primary font-medium transition-colors",
    menuItemDisabled: "px-4 py-2",
    selectAllContainer: "px-4 py-2 mt-1 hover:bg-canvas cursor-pointer",
    divider: "border-t border-border my-1",
    resetButton: "absolute right-2 top-1/2 transform -translate-y-1/2 p-2 text-text_secondary hover:text-primary",
    highlight: "ring-2 ring-primary ring-opacity-50 border-primary",
    selectedText: "text-primary font-semibold",
    placeholderText: "text-text_secondary",
  },
}
